"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const currentRouteId_1 = __importDefault(require("root/src/client/logic/route/selectors/currentRouteId"));
const currentRouteParams_1 = __importDefault(require("root/src/client/logic/route/selectors/currentRouteParams"));
const querySelector_1 = __importDefault(require("root/src/client/logic/route/selectors/querySelector"));
const languageCodeSelector_1 = __importDefault(require("root/src/client/logic/route/selectors/languageCodeSelector"));
exports.default = (state) => {
    var _a, _b;
    return ({
        routeId: (0, currentRouteId_1.default)(state),
        routeParams: (0, currentRouteParams_1.default)(state),
        query: (0, querySelector_1.default)(state),
        languageCode: (0, languageCodeSelector_1.default)(state),
        href: (_b = (_a = global === null || global === void 0 ? void 0 : global.window) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.href,
    });
};
